import React, { FunctionComponent } from 'react';

// Translate
import { Translate } from 'react-localize-redux';

// Components
import Radio from '@components/form/radio';
import Grid from '@components/basics/grid';

import FilterWrapper from './filter-wrapper';

// Controllers
import DropdownCtrl from '@webapp/controllers/form/dropdown';

// Styled
import styled from 'styled-components';

import { useSelector } from 'react-redux';
import AppState from '@webapp/store/state';
import QuestionMarkHelper from '@components/basics/question-mark-helper';
import { filterSupportedPlatforms } from '@webapp/store/artist-analytics/selector';

interface DSPsFilterProps {
  className?: string;
  analyticsDsps: string[];
  onDspsFilterChange: (value: string[]) => void;
}

const DSPsFilter: FunctionComponent<DSPsFilterProps> = ({
  className,
  analyticsDsps,
  onDspsFilterChange,
}) => {
  const stores = useSelector((state: AppState) => {
    return filterSupportedPlatforms(state.categories.lists.platform).map(
      (val) => {
        return {
          value: val.metadata.id,
          label: val.name,
        };
      }
    );
  });
  const [dsps, setDsps] = React.useState<string[]>(analyticsDsps);
  const [dspsFilter, setDSPsFilter] = React.useState('');

  const isSelected = (dsp: string) => {
    const allSelected = stores.length === dsps.length;
    if (dsp === 'all') {
      return allSelected;
    }

    if (dsps.find((a) => dsp === a)) {
      return true;
    }

    return false;
  };

  const handleDSPsSelection = (dsp?: string) => {
    if (!dsp) {
      isSelected('all');
    }

    if (dsp === 'all') {
      const allSelected = stores.length === dsps.length;
      let temp: string[] = [];
      if (allSelected) {
        temp = [];
      } else {
        temp = stores.map((val) => {
          return val.value;
        });
      }
      setDsps(temp);
      onDspsFilterChange(temp);
      return;
    }

    if (dsps.some((d) => d === dsp)) {
      let temp = dsps.filter((d) => d !== dsp);
      setDsps(temp);
      onDspsFilterChange(temp);
    } else if (dsp) {
      let temp = [...dsps, dsp];
      setDsps(temp);
      onDspsFilterChange(temp);
    }

    return;
  };

  return (
    <FilterWrapper
      className={className || ''}
      title={
        <TitleWrapper>
          <Translate id="ANALYTICS.MENU.FILTERS.DSP" />
          <QuestionMarkHelper
            className="with-margin-left"
            id="dspFilterHelper"
            moveRight
          >
            <Translate id="ANALYTICS.MENU.DSPFILTER.TOOLTIP" />
          </QuestionMarkHelper>
        </TitleWrapper>
      }
    >
      <DropdownCtrl
        // TODO: DEVTEAM-405 - This is just for demo. Please review the whole integration of the dropdowns.
        value={`DSPs (${dsps.length})`}
        // valueMapper={() => getDSPsTitle()}
        // uncomment hasFilter to show the search bar again
        // hasFilter
        filterLabel={<Translate id="ANALYTICS.MENU.FILTERS.DSP.SEARCH" />}
        customFilterValue={dspsFilter}
        onCustomFilter={setDSPsFilter}
        hasPillShape
      >
        <Grid gap={10}>
          <Radio
            isChecked={isSelected('all')}
            onChange={() => handleDSPsSelection('all')}
          >
            <Translate
              id="RELEASE.DATES_STORES.STORES.OPTION.ALL"
              data={{ amount: stores.length }}
            />
          </Radio>
          {stores
            .filter((option) =>
              dspsFilter
                ? option.label
                    .toLocaleLowerCase()
                    .includes(dspsFilter.toLocaleLowerCase())
                : true
            )
            .map((dsp) => (
              <Radio
                key={`dsp-${dsp.value}`}
                isChecked={isSelected(dsp.value)}
                onChange={() => handleDSPsSelection(dsp.value)}
              >
                {dsp.label}
              </Radio>
            ))}
        </Grid>
      </DropdownCtrl>
    </FilterWrapper>
  );
};

export default DSPsFilter;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;

  .with-margin-left {
    margin-left: 8px;
  }
`;
